import React from 'react'
import injectSheet from 'react-jss'

import styles from './form-line.styles'

const FormFields = ({ classes, children }) => <hr className={classes.line} />

export default injectSheet(styles)(FormFields)
